module.exports = __webpack_public_path__ + "static/media/domofon.e5f2125b.jpg";